import {
    cancelOrder,
    resetCart,
    setCollectMode,
    setRestaurant,
    removeProductFromCart
} from 'shared/store/ecommerce/order'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import {
    fetchRestaurantData,
    isRestaurantAvailable
} from 'shared/store/restaurant'
import { CCAlertComponent } from './CCAlertComponent'
import type { DeviceCheck, RestaurantShortDTO } from 'shared/types'
import type { RootState } from 'shared/store/reducers'
import type { Dispatch } from 'redux'
import { fetchCatalog } from 'shared/store/ecommerce/catalog'
import type { PurchasableItem } from 'shared/store/ecommerce/order'

const mapStateToProps = (state: RootState) => {
    const {
        currentToken,
        cacOrders,
        products,
        promotions,
        collectMode,
        restaurant
    } = state.ecommerceOrderState

    const hasCart = products?.length > 0 || promotions?.length > 0
    const currentOrder = currentToken && cacOrders && cacOrders[currentToken]

    return {
        hasCart,
        productsInCart: products,
        currentOrder: {
            collectMode,
            id: currentOrder && currentOrder.id,
            restaurant,
            token: currentToken
        }
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    resetCart: () => d(resetCart()),
    fetchRestaurantData: (frNumber: string) => d(fetchRestaurantData(frNumber)),
    setRestaurant: (r: RestaurantShortDTO) => d(setRestaurant(r)),
    isRestaurantAvailable: (restaurantId: string) =>
        d(isRestaurantAvailable(restaurantId)),
    setCollectMode: (collectMode: string) => d(setCollectMode(collectMode)),
    fetchCatalog: (id: string) => d(fetchCatalog(id)),
    cancelOrder: (id: string, token: string, deviceCheckPayload: DeviceCheck) =>
        d(cancelOrder(id, token, deviceCheckPayload)),
    removeProductFromCart: (product: PurchasableItem) =>
        d(removeProductFromCart(product)),
    navigate: (to: string) => d(push(to))
})

const CCAlert = connect(mapStateToProps, mapDispatchToProps)(CCAlertComponent)

export { CCAlert }
